<ul class="dx-d-side-dropdown-list">
  <ng-container *ngFor="let item of items">
    <li class="dx-d-side-dropdown-list__item"
        [title]="item.hint"
        [ngClass]="{'dx-d-side-dropdown-list__item--active': isActiveItem(item)}"
        (click)="onListItemClick(item)">
      <a class="dx-d-side-dropdown-list__item_label">{{item.title}}</a>
    </li>
  </ng-container>
</ul>
